import * as React from "react";
const SvgParty = ({ title, titleId, ...props }) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      d="M10.5 2a2.5 2.5 0 0 0-1.3 4.636L7.637 20.032c-.122 1.043.707 1.984 1.788 1.934 4.352-.201 7.406-1.188 10.69-2.992.952-.522 1.168-1.76.516-2.587L12.478 6.029A2.5 2.5 0 0 0 10.5 2Zm-1 2.5a1 1 0 1 1 2 0 1 1 0 0 1-2 0Zm1.744 2.387 4.164 5.29c-2.208.093-4.188-.917-5.162-1.568l.422-3.615c.2-.013.392-.05.576-.107Zm-1.49 7.946.3-2.582c1.43.813 3.825 1.77 6.447 1.314l2.008 2.551c-1.767.469-3.548.383-5.105.056-1.582-.332-2.889-.902-3.65-1.339Zm-.187 1.6c.897.444 2.123.913 3.53 1.207 1.884.395 4.144.489 6.397-.252a.226.226 0 0 1-.1.272c-3.098 1.7-5.93 2.617-10.038 2.807a.227.227 0 0 1-.229-.261l.44-3.774ZM4.53 10a.75.75 0 0 1 .75.75v1h.97a.75.75 0 0 1 0 1.5h-.97v1a.75.75 0 0 1-1.5 0v-1H2.75a.75.75 0 0 1 0-1.5h1.03v-1a.75.75 0 0 1 .75-.75ZM18.53 4a.75.75 0 0 1 .75.75v1h.97a.75.75 0 0 1 0 1.5h-.97v1a.75.75 0 0 1-1.5 0v-1h-1.03a.75.75 0 0 1 0-1.5h1.03v-1a.75.75 0 0 1 .75-.75Z"
      fill="currentColor"
    />
  </svg>
);
export default SvgParty;
